/* unplugin-vue-components disabled */import script from "./GreenRoomPage.vue?vue&type=script&setup=true&lang=js"
export * from "./GreenRoomPage.vue?vue&type=script&setup=true&lang=js"

import "./GreenRoomPage.vue?vue&type=style&index=0&id=a9375cdc&scoped=true&lang=less"

import exportComponent from "/Users/zhangxuan/Documents/Projects/VinesDjango/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a9375cdc"]])

export default __exports__